import { PageState } from 'models/PageState';
import { BaseGtmEvent, CheckoutEvent, ClearEcommerceEvent } from 'store/googleTagManager/types';
import { mapCartToGtm } from './utils';
import { getClearEcommerceEvent } from 'store/googleTagManager/events/genericEvents';
import { GtmChangePaymentMethodAction } from 'store/googleTagManager/actions';

/**
 * Returns an array with a ClearEcommerceEvent and BeginCheckoutEvent.
 *
 * Events containing an Ecommerce object should have a ClearEcommerceEvent before it.
 */
export const getBeginCheckoutEvent = (state: PageState): [ClearEcommerceEvent, CheckoutEvent] => {
  const { cart, appShell } = state;

  const items = mapCartToGtm(cart);

  return [
    getClearEcommerceEvent(),
    {
      event: 'begin_checkout',
      ecommerce: {
        cart_url: cart.cartUrl,
        currency: appShell.currencyCode,
        value: cart.totalLineAmount,
        items: items
      }
    }
  ];
};

export const getChangePaymentMethodEvent = (
  action: GtmChangePaymentMethodAction,
  state: PageState
): [ClearEcommerceEvent, CheckoutEvent] => {
  const { cart, appShell } = state;

  const items = mapCartToGtm(cart);
  return [
    getClearEcommerceEvent(),
    {
      event: 'change_payment_info',
      ecommerce: {
        cart_url: cart.cartUrl,
        currency: appShell.currencyCode,
        value: cart.totalLineAmount,
        items: items,
        payment_method: action.paymentMethod
      }
    }
  ];
};

export const getAddPaymentEvent = (state: PageState): [ClearEcommerceEvent, CheckoutEvent] => {
  const { cart, appShell } = state;

  const items = mapCartToGtm(cart);
  return [
    getClearEcommerceEvent(),
    {
      event: 'add_payment_info',
      ecommerce: {
        currency: appShell.currencyCode,
        value: cart.totalLineAmount,
        items: items
      }
    }
  ];
};

export const getAddShippingInfoEvent = (): BaseGtmEvent => {
  return {
      event: 'add_shipping_info',
    }
};

export const getAddContactInfoEvent = (): BaseGtmEvent => {
  return {
    event: 'add_contact_info'
  };
};

export const getContinueToPaymentEvent = (): BaseGtmEvent => {
  return {
    event: 'continue_to_payment'
  };
};
